import { Injectable, Signal, signal } from '@angular/core'
import { ToastMessageOptions } from 'primeng/api'

@Injectable({
    providedIn: 'root'
})
export class AlertService {
    private _alert = signal<ToastMessageOptions | null>(null)

    public get(): Signal<ToastMessageOptions | null> {
        return this._alert
    }

    public set(value: ToastMessageOptions | null): void {
        this._alert.set(value)
    }
}
